import { FunctionComponent, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, Question } from '../../App.styles';
import { ResultInfo } from '../../components/Result/Result.styles';
import { GlobalContext, updateGetNotified } from '../../contexts';
import { useMetrics } from '../../hooks';
import { metricEvents, MetricProperty, TestId } from '../../utils';
import { createBrandModelPair } from '../../utils/brandModelPair';
import {
  ActionButton,
  GetNotifiedContainer,
  Icon,
  ICON_TYPES,
  Notification,
  NotifiedDescription,
  NotifiedTitle,
  PrivacyNoticeDisclaimer,
  Text,
  TEXT_TYPES,
} from './NotCompatibleAmazon.styles';

interface GetNotifiedProps {
  brand: string;
  model: string;
}

const GetNotified: FunctionComponent<GetNotifiedProps> = ({ brand, model }) => {
  const { state: global, dispatch } = useContext(GlobalContext);
  const { track } = useMetrics();
  const { t } = useTranslation('common');

  const { amazonId, getNotified } = global;

  const brandModelPair = createBrandModelPair(brand, model);
  const optedIn = getNotified.has(brandModelPair);

  return (
    <GetNotifiedContainer
      data-testid={TestId.GetNotified}
      className="get-notified border"
    >
      <NotifiedTitle as={Question}>
        {t('results.notCompatible.getNotified.title')}
      </NotifiedTitle>

      <NotifiedDescription as={ResultInfo}>
        {t('results.notCompatible.getNotified.description')}
      </NotifiedDescription>

      {!amazonId && (
        <Notification variant="info">
          <Icon type={ICON_TYPES.INFO} />
          <Text type={TEXT_TYPES.REGULAR}>
            {t('results.notCompatible.getNotified.signInInfo')}
          </Text>
        </Notification>
      )}

      {amazonId && (
        <>
          {optedIn && (
            <Notification variant="success">
              <Icon type={ICON_TYPES.SUCCESS} />
              <Text>{t('results.notCompatible.getNotified.allSet')}</Text>
            </Notification>
          )}

          <ActionButton
            disabled={optedIn}
            className="w-100 rounded-pill"
            type="button"
            onClick={() => {
              dispatch(
                updateGetNotified({
                  getNotified: {
                    model,
                    brand,
                  },
                })
              );
              track(metricEvents.getNotifiedOptedIn, {
                [MetricProperty.getNotifiedOptedIn]: true,
                brand,
                model,
              });
            }}
          >
            {t('results.notCompatible.getNotified.optInBtn')}
          </ActionButton>
        </>
      )}

      <PrivacyNoticeDisclaimer>
        <Trans i18nKey="common:results.notCompatible.getNotified.privacyNotice">
          notice{' '}
          <Anchor
            noUnderline
            href="/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ"
          >
            link
          </Anchor>
        </Trans>
      </PrivacyNoticeDisclaimer>
    </GetNotifiedContainer>
  );
};

export default GetNotified;
